import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { changeFilter, selectFilter, selectTypeCategory } from '../store/slice'

export const Category = () => {
  const dispatch = useDispatch()
  const typeCategory = useSelector(selectTypeCategory)
  const filterData = useSelector(selectFilter('FileCategoryId'))
  const dataCategory = useMemo(() => typeCategory[0], [typeCategory?.length])

  const selectCategory = (value) => {
    dispatch(
      changeFilter({
        FileCategoryId: value.value,
        Page: 1,
      }),
    )
  }

  return (
    <div className="flex1">
      <Element
        elementName="p"
        style={{
          color: '#191D25',
          fontWeight: 600,
        }}
      >
        <Translate value="library.downloadedFiles.CATEGORY" />
      </Element>
      <SelectCustom
        activeItem={
          typeCategory?.find((item) => item?.value === filterData) ||
          dataCategory
        }
        data={typeCategory}
        style={{ minWidth: 120, height: 28, backgroundColor: '#FFFFFF' }}
        isI18n
        chooseItem={selectCategory}
      />
    </div>
  )
}
